import React from 'react';
import IconContainer from './icon_container';

export default props => (
  <IconContainer viewBox="0 0 51 51" className="circle-x-icon">
    <g strokeWidth="2" fill="none" stroke="#000" className="circle-x-icon-path">
      <circle cx="24" cy="24" r="23" />
      <path d="M16 16l16 16M16 32l16-16" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </IconContainer>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/circle_x_icon.jsx